import React, { memo, useMemo } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { areEqual } from 'Utils/equalityChecks';
import { useCustomReports } from 'Context/CustomReports';
import { ReportCard } from '../ReportCard/ReportCard';
import classes from './projectStatusChart.module.css';

function ProjectStatusChart() {
  const { projectsByStatus }: any = useCustomReports();
  const { data, loading, error } = projectsByStatus;

  const chartData = useMemo(() => {
    if (!data || data.length === 0) return [];

    const counts: Record<string, number> = {};
    data.forEach((row: any) => {
      const status = row['status.name'] || 'Unknown';
      counts[status] = (counts[status] || 0) + 1;
    });

    return Object.entries(counts)
      .map(([name, count]) => ({ name, count }))
      .sort((a, b) => b.count - a.count);
  }, [data]);

  return (
    <ReportCard
      title="Projects by Status"
      subtitle="Distribution of projects across workflow statuses"
      loading={loading}
      error={error}
      configKey="projectsByStatus"
    >
      {chartData.length > 0 ? (
        <div className={classes.chartWrapper}>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={chartData} layout="vertical" margin={{ top: 5, right: 30, left: 80, bottom: 5 }}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis type="number" allowDecimals={false} />
              <YAxis type="category" dataKey="name" width={70} tick={{ fontSize: 12 }} />
              <Tooltip />
              <Bar dataKey="count" fill="#9A00FF" radius={[0, 4, 4, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      ) : (
        <p className={classes.emptyState}>No project data available.</p>
      )}
    </ReportCard>
  );
}

const ProjectStatusChartMemo = memo(ProjectStatusChart, areEqual);
export { ProjectStatusChartMemo as ProjectStatusChart };
